<!--
  @author:gll
  @time:2019/8/8
  @disc:商品权限配置
 -->

<template>
  <div class="customer-manager" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" label-width="70px" inline class="table-search-bar">
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="form.customerName" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="table"
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="userName"
        label="用户名"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="contactPhone"
        label="注册手机"
        width="100px">
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="companyAddress"
        label="公司所在地"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="430px">
        <template slot-scope="scope">
          <el-button @click="configPermission(scope.row)" v-permission="'0030801'">配置权限</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="multiple-config">
      <div class="multiple-button">
        <el-button type="primary" @click="multipleConfig" v-permission="'0030801'">批量配置</el-button>
      </div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listState.total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
    <config-dialog :show.sync="configDialogShow" :info="configDialogInfo"> </config-dialog>
    <multiple-config-dialog :show.sync="multipleDialogShow" :info="multipleDialogInfo"> </multiple-config-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import configDialog from './configDialog'
import multipleConfigDialog from './multipleConfigDialog'
export default {
  name: 'customerManager',
  components: {
    configDialog,
    multipleConfigDialog
  },
  data () {
    return {
      form: {
        userName: '',
        customerName: ''
      },
      configDialogShow: false,
      configDialogInfo: '',
      multipleDialogShow: false,
      multipleDialogInfo: ''
    }
  },
  computed: {
    ...mapGetters({ list: 'getChemicalsPermissionList', listState: 'getChemicalsPermissionState' })
  },
  methods: {
    ...mapActions([
      'getChemicalsPermissionList',
      'getPermissionInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getChemicalsPermissionList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getChemicalsPermissionList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getChemicalsPermissionList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 配置权限
    async configPermission (row) {
      let cusInfo = await this.getPermissionInfo({ accountId: row.accountId })
      this.configDialogInfo = { permissionList: cusInfo, accountId: row.accountId, customerName: row.customerName }
      this.configDialogShow = true
    },
    multipleConfig () {
      this.multipleDialogInfo = {}
      this.multipleDialogShow = true
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style lang="scss" scoped>
.multiple-config{
  overflow: hidden;
  margin-top: 10px;
}
.multiple-button{
  float: left;
  margin-top: 15px;
}
.el-pagination {
  float: right;
}
</style>
